import { createSlice } from '@reduxjs/toolkit'
import { correspondenceLogsType } from '../types/correspondenceLogs.types'

const initialState: correspondenceLogsType = {
  content: null,
  selected: null,
  totalPages: null,
  filteredContent: null,
  jsonData: null,
  documentEntities: null,
}

const correspondenceLogsSlice = createSlice({
  name: 'correspondenceLogs',
  initialState: initialState,
  reducers: {
    updateCorrespondenceLogsData: (state, action) => {
      state.content = action.payload
    },
    updateTotalPagesCorrespondenceLogs: (state, action) => {
      state.totalPages = action.payload
    },
    getAllCorrespondenceLogsAction: () => {
      return
    },
    filterCorrespondenceLogsData: (state, action) => {
      state.selected = action.payload
    },
    clearCorrespondenceLogsData: (state) => {
      state.filteredContent = null
    },
    updateCorrespondenceFilterData: (state, action) => {
      state.filteredContent = action.payload
    },
    updateSelectedCorrespondenceLogState: (state, action) => {
      state.previewSelected = action.payload
    },
    getPreviewCorrespondenceDataView: (state, _action) => {
      return state
    },
  },
})

export const {
  updateCorrespondenceLogsData,
  updateTotalPagesCorrespondenceLogs,
  getAllCorrespondenceLogsAction,
  filterCorrespondenceLogsData,
  clearCorrespondenceLogsData,
  updateCorrespondenceFilterData,
  getPreviewCorrespondenceDataView,
  updateSelectedCorrespondenceLogState,
} = correspondenceLogsSlice.actions
export default correspondenceLogsSlice.reducer
